export enum ApprovalType {
	EducationTeamDelegation = "Awaiting Approval",	
}